module.exports = __webpack_public_path__ + "img/Screenshot_2.bce66f4d.png";